// The first part of the profile (TX-US-0034): what a counterparty is at a glance - its name and
// status and what the status does not say (StatusNotes.jsx), what it is to Auremin, where it is,
// who added and last changed it. The actions that move it are at the end of the onboarding path
// (TX-US-0042).

import { Link } from 'react-router';

import { countryLabel } from '../../countries.js';
import { useMe } from '../../MeContext.js';
import { COUNTERPARTY_EDITOR_ROLES, holdsAny } from '../../roles.js';
import Icon from '../../ui/Icon.jsx';
import { categories, commodities, rating, status } from '../cells.jsx';
import useProducts from '../useProducts.js';
import StatusNotes from './StatusNotes.jsx';

const when = (iso) => new Date(iso).toLocaleString();

export default function BasicDetails({ record }) {
  const me = useMe();
  const { products } = useProducts();
  const changed = record.updated_at && record.updated_at !== record.created_at;

  return (
    <section className="profile-panel" aria-label="Basic details">
      <header className="register-header">
        <h2>{record.name} {status(record)}</h2>
        {holdsAny(me, COUNTERPARTY_EDITOR_ROLES) && (
          <Link className="icon-button primary" to={`/counterparties/${record.counterparty_id}/edit`}
                aria-label={`Edit ${record.name}`} title="Edit">
            <Icon name="pencil" />
          </Link>
        )}
      </header>

      <dl className="deal-fields">
        <StatusNotes record={record} />
        <dt>Categories</dt>
        <dd>{categories(record)}</dd>
        <dt>Commodities</dt>
        <dd>{commodities(record, products)}</dd>
        <dt>Rating</dt>
        <dd>{rating(record)}</dd>
        <dt>Country</dt>
        <dd>{record.country ? countryLabel(record.country) : '—'}</dd>
        {(record.city || record.region) && (
          <>
            <dt>City and region</dt>
            <dd>{[record.city, record.region].filter(Boolean).join(', ')}</dd>
          </>
        )}
        <dt>Added</dt>
        <dd>
          {record.created_by ?? '—'}
          {record.created_at && <>, {when(record.created_at)}</>}
        </dd>
        {changed && (
          <>
            <dt>Last changed</dt>
            <dd>{record.updated_by}, {when(record.updated_at)}</dd>
          </>
        )}
      </dl>
    </section>
  );
}
